import { useTheme } from './useTheme';

export type ThemeExclusiveRoom = 'ash-embers' | 'twilight-stars' | 'void-abyss' | 'eclipse-shadows' | 'dawn-awakening';

export const useThemeRooms = () => {
  const { theme } = useTheme();
  
  // Check if Dawn theme is available (5-7 AM only)
  const isDawnAvailable = (): boolean => {
    const hour = new Date().getHours();
    return hour >= 5 && hour < 7;
  };

  const isRoomAvailable = (roomId: ThemeExclusiveRoom): boolean => {
    switch (roomId) {
      case 'ash-embers':
        return theme === 'ash';
      case 'twilight-stars':
        return theme === 'twilight';
      case 'void-abyss':
        return theme === 'void';
      case 'eclipse-shadows':
        return theme === 'eclipse';
      case 'dawn-awakening':
        return theme === 'dawn' && isDawnAvailable();
      default:
        return false;
    }
  };

  const getRequiredTheme = (roomId: ThemeExclusiveRoom): string => {
    switch (roomId) {
      case 'ash-embers':
        return 'Ash';
      case 'twilight-stars':
        return 'Twilight';
      case 'void-abyss':
        return 'Void';
      case 'eclipse-shadows':
        return 'Eclipse';
      case 'dawn-awakening':
        return 'Dawn (5-7 AM)';
      default:
        return 'Unknown';
    }
  };

  const getThemeExclusiveRooms = () => {
    const rooms: ThemeExclusiveRoom[] = ['ash-embers', 'twilight-stars', 'void-abyss', 'eclipse-shadows', 'dawn-awakening'];
    return rooms.filter(room => isRoomAvailable(room));
  };

  return {
    theme,
    isDawnAvailable,
    isRoomAvailable,
    getRequiredTheme,
    getThemeExclusiveRooms,
  };
};
